import { FEATURE_KEYS } from './subscriptionEnums.js';

export default ({ baseUrl, feature, plan, email }) => {
  const upgradeSubscriptionUrl = new URL(baseUrl);
  if (Object.values(FEATURE_KEYS).includes(feature)) {
    upgradeSubscriptionUrl.searchParams.append('feature', feature);
  }
  upgradeSubscriptionUrl.searchParams.append('currentPlan', plan);
  upgradeSubscriptionUrl.searchParams.append('email', email);

  return upgradeSubscriptionUrl;
};
